module.exports = __webpack_public_path__ + "static/media/appstore-2d.8d2e084a.png";